import React, { useState } from "react";
import parse from "html-react-parser";
import VideoModal from "../VideoModal";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import { Icon } from "@iconify/react";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { generateEventId, trackLeadSubmission } from '../../utils/analytics';

export default function Hero({
  title,
  subTitle,
  bgUrl,
  smallbgUrl,
  imgUrl,
  videoBtnText,
  videoUrl,
  infoList,
  dateList,
  contactList,
  btnText,
  btnUrl,
}) {
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFormData((prevFormData) => ({
      ...prevFormData,
      date: date ? date.toISOString().split("T")[0] : "",
    }));
  };

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    date: "",
    phone: "",
  });

  // Handler for input field changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  console.log(formData);

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    // Generate unique event ID for Meta Pixel ⇔ CAPI deduplication
    const eventId = generateEventId();
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/booknow`,
        {
          ...formData,
          event_id:  eventId,
          form_type: 'quick_booking_bar',
        }
      );
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Thank You for Contacting Us!',
          text: 'Our team will connect with you shortly to assist you.',
        });

        // Push dataLayer event for GTM → Meta Pixel deduplication
        trackLeadSubmission('quick_booking_bar', eventId, {
          name:  formData.name,
          phone: formData.phone,
        });
  
        setFormData({ name: "", phone: "", date: "" });
        setSelectedDate(null);
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error occurred while sending data. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container bgUrl={bgUrl} smallbgUrl={smallbgUrl}>
      <section className="cs_hero cs_style_1">
        <div
          className="cs_hero_wrap"
          style={{
            '--desktop-bg': `url(${bgUrl})`,
            '--mobile-bg': `url(${smallbgUrl})`
          }}
        >
          <div className="container">
            <div className="cs_hero_text">
              <h1 className="cs_hero_title cs_fs_94 mobile_hero_title">{parse(title)}</h1>
              <p className="cs_hero_subtitle cs_fs_20 cs_heading_color mobile_hero_subtitle">
                {parse(subTitle)}
              </p>
              <div className="cs_hero_btn_wrap mb-5 mobile_hero_btn">
                <VideoModal
                  videoUrl={videoUrl}
                  videoBtnText={videoBtnText}
                  variant="cs_heading_color"
                />
              </div>
            </div>

            <form
              method="POST"
              className="st-appointment-form"
              id="BookNow"
              onSubmit={onSubmit}
              
            >
              <div className="cs_hero_info_wrap cs_shadow_1 cs_white_bg cs_radius_15">
                {infoList.map((item, index) => (
                  <div className="cs_hero_info_col" key={index}>
                    <div className="cs_hero_info d-flex align-items-center">
                      <div className="cs_hero_info_icon cs_center rounded-circle cs_accent_bg">
                        <img src={item.iconUrl} alt="Icon" />
                      </div>
                      <div className="cs_hero_info_right">
                        <h3 className="cs_hero_info_title cs_semibold">
                          {item.title}
                        </h3>
                        <div className="cs_hero_info_subtitle cs_fs_20">
                          <input
                            type="text"
                            id={`name_${index}`}
                            name="name"
                            placeholder={`Enter ${item.title}`}
                            onChange={handleInputChange}
                            value={formData.name}
                            required
                            className="input-field"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {dateList.map((item, index) => (
                  <div className="cs_hero_info_col" key={index}>
                    <div className="cs_hero_info d-flex align-items-center">
                      <div className="cs_hero_info_icon cs_center rounded-circle cs_accent_bg">
                        <img src={item.iconUrl} alt="Icon" />
                      </div>
                      <div className="cs_hero_info_right">
                        <h3 className="cs_hero_info_title cs_semibold">
                          {item.title}
                        </h3>
                        <div className="cs_hero_info_subtitle cs_fs_20">
                          <DatePicker
                            name="date"
                            type="date"
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="dd/mm/yyyy"
                            id="date"
                            className="input-field"
                            required
                            isClearable
                            minDate={new Date()}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {contactList.map((item, index) => (
                  <div className="cs_hero_info_col" key={index}>
                    <div className="cs_hero_info d-flex align-items-center">
                      <div className="cs_hero_info_icon cs_center rounded-circle cs_accent_bg">
                        <img src={item.iconUrl} alt="Icon" />
                      </div>
                      <div className="cs_hero_info_right">
                        <h3 className="cs_hero_info_title cs_semibold">
                          {item.title}
                        </h3>
                        <div className="cs_hero_info_subtitle cs_fs_20">
                          <PhoneInput
                            country={'in'}
                            enableSearch={true}
                            value={formData.phone}
                            onChange={(phone) => setFormData({ ...formData, phone: '+' + phone })}
                            inputClass="input-field"
                            inputStyle={{ width: '100%', height: '40px', paddingLeft: '45px', border: 'none', borderBottom: '1px solid #ccc', borderRadius: '8px' }}
                            buttonStyle={{ backgroundColor: 'transparent', border: 'none', borderBottom: '1px solid #ccc', paddingLeft: '5px' }}
                            containerStyle={{ width: '100%' }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="cs_hero_info_col mt-lg-3">
                  <button
                    type="submit"
                    id="appointment-submit"
                    className="cs_btn cs_style_1 cs_mcp_btn"
                  >
                    <span>{loading ? "Sending" : "Book Now"}</span>
                    <Icon icon="fa6-solid:arrow-right" className="cs_mcp_btn_icon" />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </Container>
  );
}

const Container = styled.div`
  .input-field {
    border: none;
    border-bottom: 1px solid #ccc;
    padding: 8px 12px;
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 8px;
  }

  .input-field:focus {
    outline: none;
    border-color: #f58220;
  }
`;
